<div class="page-container">
  <div class="page-title-block">
    <div class="page-type">Single / Multi Selection Page</div>
    <div class="more-info-btn" (click)="openMoreInfo()">More info</div>
  </div>
  <ng-container *ngTemplateOutlet="selectionPagesForm"></ng-container>
  <div class="more-info-container" [ngClass]="{ 'open': moreInfoOpened }">
    <div class="close-btn-block">
      <button class="close-btn" (click)="closeMoreInfo()">Close</button>
    </div>
    <div class="title">Single / Multi Selection Page</div>
    <img src="../../../../../../../../../../assets/img/ABF_more_info/selectPage.jpg" alt="More info">
    <div class="desc">A single / multi selection page allows a user to select a single option or multiple options from a list.</div>
    <div class="desc eg">E.G. Choosing a list of menu items</div>
  </div>
</div>

<ng-template #selectionPagesForm>
  <div class="page-content">
    <ng-container [formGroup]="selectPageForm">
      <div class="fields-block">
        <div class="form-field-block">
          <div class="label-container">
            <label class="label">Page Header</label>
            <label class="optional">Optional</label>
          </div>
          <input class="input-field" placeholder="Enter page header" [formControlName]="'pageHeader'" (ngModelChange)="setPageDataHandler()"/>
        </div>
        <div class="form-field-block">
          <div class="label-container">
            <label class="label">Page Subheader</label>
          </div>
          <input class="input-field" placeholder="Enter subheader" [formControlName]="'pageSubHeader'"/>
          <input-validators controlName="pageSubHeader" [control]="selectPageForm.controls['pageSubHeader']"></input-validators>
        </div>
        <div class="toggle-field">
          <div class="label-left-block">
            <label class="label">Multiple Selection</label>
            <app-cms class="popover" [type]="'nodeBuild'" [field]="'AMBmultipleSelections'"></app-cms>
          </div>
          <div class="toggle-btn">
            <mat-slide-toggle [color]="'primary'" class="control-toggle" [formControlName]="'multipleSelection'">
            </mat-slide-toggle>
          </div>
        </div>
        <span class="line"></span>
      </div>
    </ng-container>
    <div class="options-block">
      <div class="add-option-block">
        <button class="add-option-btn" (click)="addOption()">Add Option</button>
        @if (selectPageFormOptions.value.length > 0) {
          <div class="options-count">
            {{ selectPageFormOptions.value.length }} {{ selectPageFormOptions.value.length > 1 ? 'options' : 'option' }}
          </div>
        }
      </div>
      <div class="options-list" (cdkDropListDropped)="dropOption($event)" cdkDropList>
        @for (selectOption of selectPageFormOptions.controls; track selectOption; let index = $index) {
          <div cdkDrag>
            <div class="custom-placeholder" *cdkDragPlaceholder></div>
            <div id="option-{{index}}" [formGroup]="selectOption" class="option-item option-{{index}}">
              <input [formControlName]="'identifier'" hidden/>
              @if (updateImage) {
                <div class="add-image">
                  <input #imageRef [formControlName]="'imageRef'" hidden>
                  <select-media [image]="imageRef.value" [imageOnly]="true" (setImageRef)="setImage($event, selectOption)" class="vertical">
                  </select-media>
                </div>
              }
              <div class="fields">
                <div class="form-field-block option-field option-title">
                  <input class="input-field" placeholder="Option title" [formControlName]="'text'"/>
                  <input-validators controlName="text" [control]="selectOption.controls['text']"></input-validators>
                </div>
                <div class="form-field-block option-field">
                  <input class="input-field" placeholder="Value (e.g. Product Code/SKU/Unique ID)" [formControlName]="'value'"/>
                  <input-validators controlName="value" [control]="selectOption.controls['value']"></input-validators>
                </div>
              </div>
              <div class="controls">
                <div class="move-btn" cdkDragHandle></div>
                <div class="remove-btn" [matTooltip]="'Minimum 1 option required'"
                  matTooltipClass="menu-form-option-remove-btn-toolTip" matTooltipPosition="above"
                  [matTooltipDisabled]="selectPageFormOptions.controls.length > 1"
                  [ngClass]="{'disabled-btn' : selectPageFormOptions.controls.length === 1} "
                (click)="removeOption(index)"></div>
              </div>
            </div>
          </div>
        }
      </div>
    </div>
  </div>
</ng-template>
